














import Vue from 'vue'

/*example
2 ways to use:

  1. pass header props (simple)
      <collapsible-group header="Metrics" :collapsed="true">
        <a href="#">Services1</a>
        <a href="#">Services2</a>
      </collapsible-group>

  2. can pass named slot if you want custom html
      <collapsible-group>
        <template #header>
          <h3>Meta</h3>
        </template>
        <a href="#">About</a>
      </collapsible-group>
* */
export default Vue.extend({
  props: {
    header: {
      type: String
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: this.collapsed
    }
  },
  methods: {
    onHeaderClick() {
      this.isCollapsed = !this.isCollapsed
    }
  }
})
